module.exports = __webpack_public_path__ + "img/PS37.a05f253e.png";